module.exports = __webpack_public_path__ + "static/media/IconMore.6fbc20d1.svg";